import { Eye, Headphones, BookOpen, Hand } from "lucide-react";

export const STYLE_META = {
    visual: { label: "Visual", color: "bg-blue-100 text-blue-800 border-blue-200", Icon: Eye },
    auditivo: { label: "Auditivo", color: "bg-purple-100 text-purple-800 border-purple-200", Icon: Headphones },
    "lector-escritor": {
        label: "Lector-Escritor",
        color: "bg-emerald-100 text-emerald-800 border-emerald-200",
        Icon: BookOpen,
    },
    kinestesico: {
        label: "Kinestésico",
        color: "bg-orange-100 text-orange-800 border-orange-200",
        Icon: Hand,
    },
};

export default function LearningStyleBadge({ style, size = "md" }) {
    const meta = STYLE_META[style] || {
        label: "Sin asignar",
        color: "bg-gray-100 text-gray-700 border-gray-200",
        Icon: Eye,
    };
    const Icon = meta.Icon;
    const cls = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-full border ${meta.color} ${cls} font-medium`}
            data-testid="learning-style-badge"
        >
            <Icon size={size === "lg" ? 14 : 12} />
            {meta.label}
        </span>
    );
}
